import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Menu, MenuItem } from '@mui/material';
import './contextmenu.sass';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
export const ContextMenuForGeozone = memo(function ContextMenuForGeozone(props) {
    const { coordinates, onClose, onOpenGeozoneProperties } = props;
    const { mouseY, mouseX } = coordinates;
    const onCloseContextMenu = useCallbacks([preventDefault, onClose]);
    const onGeozoneProperties = useCallbacks([
        preventDefault,
        onOpenGeozoneProperties,
        onClose,
    ]);
    return (_jsx(Menu, { keepMounted: true, open: mouseY != null, onClose: onCloseContextMenu, anchorReference: "anchorPosition", anchorPosition: mouseY != null && mouseX != null
            ? {
                top: mouseY,
                left: mouseX,
            }
            : undefined, children: _jsx(MenuItem, { onClick: onGeozoneProperties, children: "\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u0430 \u0433\u0435\u043E\u0437\u043E\u043D\u044B" }) }));
});
